"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withDelayedAppearance = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importDefault(require("styled-components"));
/**
 * HOC that adds delayed appearance animation to the component
 * Animation starts after delay and lasts for duration
 *
 * @param Component - component to wrap
 * @param delay - delay before animation starts
 * @param duration - duration of the animation
 */
function withDelayedAppearance(Component, delay, duration) {
    const StyledComponent = (0, styled_components_1.default)(Component) `
    opacity: 0;

    &.appearance-enter {
      opacity: 0;
    }

    &.appearance-enter-active {
      opacity: 1;
      transition: opacity ${duration}ms ease-in;
    }

    &.appearance-enter-done {
      opacity: 1;
    }
  `;
    return function WithDelayedAppearance(props) {
        const [show, setShow] = (0, react_1.useState)(false);
        (0, react_1.useEffect)(() => {
            const timeout = setTimeout(() => setShow(true), delay);
            return () => clearTimeout(timeout);
        }, []);
        return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: show, timeout: duration, classNames: "appearance", "data-e2e": 'withDelayedAppearance_CSSTransition', children: (0, jsx_runtime_1.jsx)(StyledComponent, Object.assign({}, props, { "data-e2e": 'withDelayedAppearance_StyledComponent' })) }));
    };
}
exports.withDelayedAppearance = withDelayedAppearance;
